module.exports = __webpack_public_path__ + "static/co-banner-e3ed377706754e7860e0a68c78d29dfc.png";